import { RuntimeLoader } from '@rive-app/react-canvas';
import riveWasmUrl from '@rive-app/canvas/rive.wasm?url';

RuntimeLoader.setWasmUrl(riveWasmUrl);

void RuntimeLoader.awaitInstance();
